import React from 'react'

// The product name, shown on every page a user can reach WITHOUT being logged
// in: login, forgot password, set/reset password, and the expired-link page.
//
// One component rather than four copies of a string. These pages are edited
// at different times for different reasons -- the expired-link page only
// exists because of the phase-12 pre-check (d323d0ee) -- so four literals
// would drift, and a product rename would be four greps and a miss.
//
// Styling is inline, not a class, on purpose. The four pages pull in two
// different stylesheets (signin.scss and resetpassword.scss) and the shared
// mixins are imported separately by each, so a new shared class would have to
// be added in two places to render everywhere. Inline keeps it correct on all
// four with no CSS plumbing, which is also how these pages already size their
// cards.
//
// #012448 is the brand dark blue -- $mobile-primary-blue in css/color.scss.
// Kept as a literal because this is a plain .js component and cannot read
// scss variables.
const PortalTitle = ({ style }) => (
  <div
    style={{
      textAlign: 'center',
      color: '#012448',
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      lineHeight: 1.3,
      marginBottom: 10,
      ...style,
    }}
  >
    MoveAI Portal
  </div>
)

export default PortalTitle
